import { connect } from 'react-redux';

import _ from 'lodash';
import SearchView from './SearchView.jsx';

import { 
  searchAsset, searchGroups, searchStreams, fetchTags, invalidateAssetSearchResult,
  invalidateGroupsSearchResult, invalidateStreamsSearchResult, invalidateTags, 
  recordSearchQuery
} from 'src/legacy/redux/actions/search.jsx';
import {invalidateSeekSession} from "src/redux/actions/seek";

import { fetchCustomFields } from 'src/legacy/redux/actions/customFields.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import { trackAdoptionMetricsForContentSearchEvent } from 'src/legacy/redux/actions/adoption.jsx';

const mapStateToProps = (state, ownProps) => {

  const searchableFields = (state.legacyRootReducer.settings.customFields.items || []).filter(field => {
    return field.searchable;
  });


  return {
    account: _.get(state, "accounts.item", {}),
    assets: state.legacyRootReducer.search.assets,
    assetsSearching: state.legacyRootReducer.search.assets.searching,
    streams: state.legacyRootReducer.search.streams,
    streamsSearching: state.legacyRootReducer.search.streams.searching,
    groups: state.legacyRootReducer.search.groups,
    groupsSearching: state.legacyRootReducer.search.groups.searching,
    tags: state.legacyRootReducer.search.tags.item,
    totalItems: state.legacyRootReducer.search.tags.totalItems,
    fetchingTag: state.legacyRootReducer.search.tags.loading,
    customFields: searchableFields
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    searchAsset: (query, filter, page, limit, highlight, searchWithinHub) => {
      return dispatch(searchAsset(query, filter, page, limit, highlight, searchWithinHub));
    },
    searchStreams: (query, filter, page, limit, highlight) => {
      return dispatch(searchStreams(query, filter, page, limit, highlight));
    },
    searchGroups: (query, filter, page, limit, highlight) => {
      return dispatch(searchGroups(query, filter, page, limit, highlight));
    },
    fetchTags: (query, filter) => {
      return dispatch(fetchTags(query, filter));
    },
    fetchCustomFields: () => {
      return dispatch(fetchCustomFields());
    },
    invalidateAssetSearchResult: () => {
      return dispatch(invalidateAssetSearchResult());
    },
    invalidateGroupsSearchResult: () => {
      return dispatch(invalidateGroupsSearchResult());
    },
    invalidateStreamsSearchResult: () => {
      return dispatch(invalidateStreamsSearchResult());
    },
    invalidateTags: () => {
      return dispatch(invalidateTags())
    },
    recordSearchQuery: (context) => {
      return dispatch(recordSearchQuery(context));
    },
    trackAdoptionMetricsForContentSearchEvent: (sourceCta, searchString, filter, tags, categories) => {
      return dispatch(trackAdoptionMetricsForContentSearchEvent(sourceCta, searchString, filter, tags, categories));
    },
    invalidateSeekSession: () => {
      return dispatch(invalidateSeekSession());
    },

  }
}

const SearchPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(SearchView);

export default withUseHooks(SearchPage)
